import React, { createContext, useContext, useState } from 'react';

const BrandProductContext = createContext(null);

/**
 * Resolves product to a brand: 'striketip' or 'strikepay'.
 * - tipping → striketip
 * - payment, giving → strikepay
 * - null/undefined/other → striketip (default)
 */
export function productToBrand(product) {
  if (product === 'payment' || product === 'giving') return 'strikepay';
  return 'striketip';
}

export function BrandProductProvider({ children }) {
  const [product, setProduct] = useState(null);
  const brand = productToBrand(product);
  return (
    <BrandProductContext.Provider value={{ product, setProduct, brand }}>
      {children}
    </BrandProductContext.Provider>
  );
}

export function useBrandProduct() {
  const ctx = useContext(BrandProductContext);
  return ctx || { product: null, setProduct: () => {}, brand: 'striketip' };
}
